import { AcademyEditableSettingT } from 'types/shared/core/Academy';

const updatableKeys: (keyof AcademyEditableSettingT)[] = [
  'confStudentProfileStudentSideEdit',
  'postCommentIsGeneralBoardEabled',
  'postCommentIsClassBoardEabled',
  'postCommentIsNoteEnabled',
  'postNoteExtSearch',
];

export const AcademyEditableSetting = {
  updatableKeys,
} as const;
